import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ClientItemComponent } from '../client-item/client-item.component';
import { CircleTextAvatarComponentModule } from '../shared/circle-text-avatar/circle-text-avatar.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, CircleTextAvatarComponentModule, LazyLoadImageModule],
  declarations: [ClientItemComponent],
  exports: [ClientItemComponent],
})
export class ClientItemComponentModule {}
